import { Pipe, PipeTransform } from '@angular/core';
import { EnumConverter } from '../classes';
import { COMMISSION_SOURCE } from '../enums';

@Pipe({
  name: 'agentCommissionSource'
})
export class AgentCommissionSourcePipe extends EnumConverter implements PipeTransform {
  enumeration = COMMISSION_SOURCE;
}

